<template>
  <modal>
    <template v-slot:icon>
      <div class="popup__icon popup__icon_warning">
        <svg class="icon icon-warning_100"><use xlink:href="#icon-warning_100"></use></svg>
      </div>
    </template>
    <template v-slot:header>
      <h4 class="h4 mb-3">{{ title }}</h4>
    </template>
    <template v-slot:body>
      <p>{{ text }}</p>
    </template>
  </modal>
</template>

<script>
import Modal from '@/components/common/Modal'

export default {
  name: 'ErrorModal',
  components: {
    Modal
  },
  props: {
    title: {
      type: String,
      default: 'Произошла незарегистрированная ошибка.'
    },
    text: {
      type: String,
      default: 'Пожалуйста, перезагрузите страницу и повторите последнее действие. Если ошибка повторилась - обратитесь в техническую поддержку.'
    }
  }
}
</script>
